// THIS FILE IS AUTO GENERATED

/**
 * @deprecated Prefer to use {@link '../IconWrapper/IconWrapper'}
 * @see {@link '../../assets/icon/README.md'} for more information
 **/
export enum IconNames {
  'access-rights' = 'access-rights',
  'action' = 'action',
  'activities' = 'activities',
  'activity-checkmark' = 'activity-checkmark',
  'activity-feed' = 'activity-feed',
  'activity-form' = 'activity-form',
  'activity-location-pin' = 'activity-location-pin',
  'activity-message' = 'activity-message',
  'activity-person' = 'activity-person',
  'api' = 'api',
  'archive' = 'archive',
  'arrow-back' = 'arrow-back',
  'arrow-clock' = 'arrow-clock',
  'arrow-down' = 'arrow-down',
  'arrow-forward' = 'arrow-forward',
  'arrow-left' = 'arrow-left',
  'arrow-right' = 'arrow-right',
  'arrow-up' = 'arrow-up',
  'attach' = 'attach',
  'ava' = 'ava',
  'avatar-ava' = 'avatar-ava',
  'back' = 'back',
  'bookmark' = 'bookmark',
  'calculator' = 'calculator',
  'calendar' = 'calendar',
  'chat' = 'chat',
  'check-circle-alt' = 'check-circle-alt',
  'check-circle' = 'check-circle',
  'checkbox' = 'checkbox',
  'checklist' = 'checklist',
  'checkmark-round' = 'checkmark-round',
  'checkmark' = 'checkmark',
  'chevron-down' = 'chevron-down',
  'chevron-left-double' = 'chevron-left-double',
  'chevron-left' = 'chevron-left',
  'chevron-right' = 'chevron-right',
  'chevron-up' = 'chevron-up',
  'clinical-note' = 'clinical-note',
  'clock-square' = 'clock-square',
  'clock' = 'clock',
  'collapse' = 'collapse',
  'conditions' = 'conditions',
  'copy-outline' = 'copy-outline',
  'copy' = 'copy',
  'cross' = 'cross',
  'dashboard' = 'dashboard',
  'data-catalog' = 'data-catalog',
  'data-point' = 'data-point',
  'date-question' = 'date-question',
  'delete' = 'delete',
  'description-question' = 'description-question',
  'document' = 'document',
  'documentation' = 'documentation',
  'dot' = 'dot',
  'drag-indicator-horizontal' = 'drag-indicator-horizontal',
  'drag-indicator' = 'drag-indicator',
  'duplicate' = 'duplicate',
  'edit-outlined' = 'edit-outlined',
  'edit-pathway' = 'edit-pathway',
  'edit' = 'edit',
  'email-question' = 'email-question',
  'emr' = 'emr',
  'emr_failure' = 'emr_failure',
  'emr_success' = 'emr_success',
  'episode-end' = 'episode-end',
  'error' = 'error',
  'exclamation-mark' = 'exclamation-mark',
  'expand' = 'expand',
  'external-link' = 'external-link',
  'feed-calculation' = 'feed-calculation',
  'feed-checklist' = 'feed-checklist',
  'feed-documentation' = 'feed-documentation',
  'feed-form' = 'feed-form',
  'feed-message' = 'feed-message',
  'feed-reminder' = 'feed-reminder',
  'feed-system-action' = 'feed-system-action',
  'feed-system-transition' = 'feed-system-transition',
  'filter' = 'filter',
  'form' = 'form',
  'fullscreen' = 'fullscreen',
  'graphql' = 'graphql',
  'growing-chart' = 'growing-chart',
  'help-outline' = 'help-outline',
  'help' = 'help',
  'hide' = 'hide',
  'home' = 'home',
  'icd10-classification' = 'icd10-classification',
  'inconnector' = 'inconnector',
  'info-question' = 'info-question',
  'informative' = 'informative',
  'language' = 'language',
  'launch' = 'launch',
  'library' = 'library',
  'lightning' = 'lightning',
  'link' = 'link',
  'lock' = 'lock',
  'logo-square' = 'logo-square',
  'logo' = 'logo',
  'logout' = 'logout',
  'long-text-question' = 'long-text-question',
  'mail' = 'mail',
  'menu' = 'menu',
  'message' = 'message',
  'minus-circle' = 'minus-circle',
  'minus' = 'minus',
  'more-horiz' = 'more-horiz',
  'more' = 'more',
  'multiple-choice-grid-question' = 'multiple-choice-grid-question',
  'multiple-choice-question' = 'multiple-choice-question',
  'next' = 'next',
  'number-question' = 'number-question',
  'outconnector' = 'outconnector',
  'paper-clip' = 'paper-clip',
  'pathway' = 'pathway',
  'pause' = 'pause',
  'play-list-icon' = 'play-list-icon',
  'play-list' = 'play-list',
  'play' = 'play',
  'plus-circle' = 'plus-circle',
  'plus' = 'plus',
  'previous' = 'previous',
  'profile' = 'profile',
  'qr-code' = 'qr-code',
  'questionnaire' = 'questionnaire',
  'refresh' = 'refresh',
  'remove-bookmark' = 'remove-bookmark',
  'remove' = 'remove',
  'rename_item' = 'rename_item',
  'repeat' = 'repeat',
  'rest' = 'rest',
  'restart' = 'restart',
  'rss-feed' = 'rss-feed',
  'search-round' = 'search-round',
  'search' = 'search',
  'sendgrid' = 'sendgrid',
  'server' = 'server',
  'settings' = 'settings',
  'shape-copy' = 'shape-copy',
  'shield' = 'shield',
  'short-text-question' = 'short-text-question',
  'show' = 'show',
  'signature-question' = 'signature-question',
  'signout' = 'signout',
  'simulate' = 'simulate',
  'single-choice-question' = 'single-choice-question',
  'slider-question' = 'slider-question',
  'sparkling-fill' = 'sparkling-fill',
  'split-view' = 'split-view',
  'step-documentation' = 'step-documentation',
  'step-start' = 'step-start',
  'step-stop' = 'step-stop',
  'step' = 'step',
  'steps-rounded-transitions' = 'steps-rounded-transitions',
  'sticky-note' = 'sticky-note',
  'sync' = 'sync',
  'tag' = 'tag',
  'thumbs-down' = 'thumbs-down',
  'thumbs-up' = 'thumbs-up',
  'timeline' = 'timeline',
  'timing' = 'timing',
  'track-activation' = 'track-activation',
  'track-end' = 'track-end',
  'track' = 'track',
  'transition-condition' = 'transition-condition',
  'transition-delay' = 'transition-delay',
  'transition-goto' = 'transition-goto',
  'transition' = 'transition',
  'turtle' = 'turtle',
  'undo' = 'undo',
  'user-settings' = 'user-settings',
  'user' = 'user',
  'variable-arrow-down-short' = 'variable-arrow-down-short',
  'variable-arrow-down-shorter' = 'variable-arrow-down-shorter',
  'variable-arrow-down' = 'variable-arrow-down',
  'variable-datapoint' = 'variable-datapoint',
  'variable-fallback' = 'variable-fallback',
  'variable-label' = 'variable-label',
  'variable-transformation' = 'variable-transformation',
  'variable' = 'variable',
  'vector' = 'vector',
  'video' = 'video',
  'warning-round' = 'warning-round',
  'warning' = 'warning',
  'webhooks' = 'webhooks',
  'yes-no-question' = 'yes-no-question'
}
